
<table *ngIf="(guacServerList && guacServerList.length > 0)"
       class="app-table" border="0" cellspacing="0">
    <tr *ngFor="let guacServer of guacServerList">
        <td class="full-width p-20">
            {{ guacServer.name }}
        </td>
        <td class="w-210 p-20">
            {{ guacServer.fqdn }}:{{ guacServer.port }}
        </td>
       <!-- <td class="w-400 p-20">
            {{ guacServer.path }}
        </td>-->
        <td class="text-align-right p-0">
            <div fxLayout="row" fxLayoutAlign="end start">
                <div class="mr-10">
                    <button type="button" mat-stroked-button color="primary" class="mat-green-600-bg "
                            (click)="guacServerInUseModal(guacServer)">Info
                    </button>
                </div>

                <div class="mr-10">
                    <button type="button" mat-stroked-button color="accent" class="mr-10"
                            (click)="edit(guacServer)">Edit
                    </button>
                </div>
            </div>
        </td>
    </tr>
</table>
